// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WXO3","col":"styles_col__3VgZb","actions":"styles_actions__MOOON","conflict":"styles_conflict__KRpsB"};